define('appkit/model/filter',[
  'datakit/model' 
], function(Model) {

  var Filter = Model.extend({

  });

  return Filter;
});
